var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('com-mheader'),_c('router-view'),_c('com-mfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }